module.exports = __webpack_public_path__ + "media/images/lp_cv-block-4-29bd6d7189afe3469738303a10af4581.webp";